import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  showPropertyLookupModal: false,
});

const modals = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.CLAIM_SHOW_PROPERTY_LOOKUP_MODAL:
      return {
        ...state,
        showPropertyLookupModal: payload.showPropertyLookupModal,
      };
    default:
      return state;
  }
};

export default modals;
